import type {CustomTextProps} from 'schema/types';

export const GroupLabelProps: CustomTextProps = {variant: 'caption'};
